//@flow

import React, { useState, useEffect } from "react";
import camelcase from "camelcase";

import { View } from "@components";
import { Tab, type TabProps } from "./tab";

type Props = $Exact<{
  title: React$Element<typeof View>[] | string,
  children: React$Element<typeof Tab>[],
  activeTab?: number,
  className: string,
  withoutPageHash?: boolean,
  onTabChange?: Function,
}>;

export function TabBar(props: Props) {
  const [activeTab, setActiveTab] = useState();
  const tabs: React$Element<typeof Tab>[] = props.children.map(tab => {
    return {
      ...tab,
      props: {
        id: tab.props.id || camelcase(tab.props.title),
        ...tab.props,
      },
    };
  });

  const hash = window.location.hash;

  useEffect(() => {
    let active = props.activeTab || 0;
    if (hash && !props.withoutPageHash) {
      const hashTabIndex = tabs.findIndex(tab => {
        const tabId = tab.props.id || "";
        return `#${tabId.replace(" ", "%20")}` == hash;
      });
      if (hashTabIndex !== -1) {
        active = hashTabIndex;
      }
    }
    handleSetActiveTab(active);
  }, []);

  function handleSetActiveTab(tabIndex: number) {
    setActiveTab(_ => tabIndex);
    const tabId = tabs[tabIndex].props.id;
    if (!props.withoutPageHash) {
      window.location.hash = tabId;
    }
  }

  function handleTabClick(idx, isDisabled) {
    return function() {
      if (!isDisabled) {
        handleSetActiveTab(idx);
        props.onTabChange && props.onTabChange(idx);
      }
    };
  }

  return (
    <div className={`d-flex flex-column tab-bar ${props.className || ""}`}>
      {props.title}
      {/* Tabs */}
      <div className="tabs d-flex">
        {React.Children.toArray(tabs)
          .filter(tab => !tab.props.isHidden)
          .map((tab, index) => {
            if (tab.props.hidden && tab.props.hidden === true) {
              return null;
            }

            return React.cloneElement(tab, {
              onClick: handleTabClick(index, tab.props.disabled),
              isActive: !!(index === activeTab),
            });
          })}
      </div>
      {/* Content */}
      <div className="tabs-content">{tabs[activeTab] && tabs[activeTab].props.children}</div>
    </div>
  );
}

TabBar.Tab = Tab;
